import React, { useState } from "react";
import ViewBundles from "./ViewBundles";
import ApiBundleCreate from "./CreateBundle";
import ShareBundle from "./ShareBundle";
import EditBundles from "./EditBundle";
import CreateAContainer from "./CreateAContainer";
import { withAuth } from "@cdk-prod/fortellis-auth-context";
import { Toast, TOAST_POSITIONS, TOAST_VARIANTS } from "cdk-radial";
import PricingListPlans from "./PricingListPlans";
import PricingAddPlan from "./PricingAddPlan";
import {
  CREATE_BUNDLES,
  EDIT_BUNDLES,
  PRICING_LIST_PLANS,
  PRICING_ADD_PLAN,
  PRICING_EDIT_PLAN,
  SHARE_BUNDLES,
  VIEW_BUNDLES,
  PRICING_SHARE_PLAN,
  BUNDLE_DOCS,
  RETIRED_PRICING_PLANS,
  BUNDLE_PRICE_PLAN_HISTORY,
  ADD_A_PLAN,
  CREATE_A_CONTAINER
} from "./screen";
import PricingSharePlan from "./PricingSharePlan";
import RetiredPricingPlans from "./RetiredPricingPlans";
import BundlePricePlanHistory from "./BundlePricePlanHistory";
import BundleDocs from "./BundleDocs";
import AddAPlan from "./AddAPlan";

function ApiBundleManagement(props) {
  const [reservedBundles, setReservedBundles] = useState([]);
  const [bundleShareName, setBundleShareName] = useState("");
  const [bundleShareId, setBundleShareId] = useState("");

  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  
  const { auth, removeToast1, ApiBundleManagementReducer } = props;
  const {screen, showSuccessToast1, toastMessage1, selectedPricingPlan, selectedBundle} = ApiBundleManagementReducer;

  const removeToast = () => {
    setShowSuccessToast(false);
    setToastMessage("");
  };

  const renderComponent = () => {
    switch (screen) {
      case VIEW_BUNDLES:
        return (
          <ViewBundles
            {...props}
            setReservedBundles={setReservedBundles}
            setBundleShareName={setBundleShareName}
            setBundleShareId={setBundleShareId}
          />
        );
      case CREATE_BUNDLES:
        return (
          <ApiBundleCreate
            {...props}
            setShowSuccessToast={setShowSuccessToast}
            reservedBundles={reservedBundles}
          />
        );
      case SHARE_BUNDLES:
        return (
          <ShareBundle
            {...props}
            bundleShareId
            bundleName={bundleShareName}
            bundleId={bundleShareId}
          />
        );
      case EDIT_BUNDLES:
        return (
          <EditBundles
            {...props}
            reservedBundles={reservedBundles}
            setShowSuccessToast={setShowSuccessToast}
          />
        );
      case PRICING_LIST_PLANS:
        return (
          <PricingListPlans
            {...props}
            setShowSuccessToast={setShowSuccessToast}
            setToastMessage={setToastMessage}
          />
        );
      case PRICING_ADD_PLAN:
        return (
          <PricingAddPlan
            {...props}
            setShowSuccessToast={setShowSuccessToast}
            setToastMessage={setToastMessage}
          />
        );
      case PRICING_EDIT_PLAN:
        return (
          <PricingAddPlan
            {...props}
            setShowSuccessToast={setShowSuccessToast}
            setToastMessage={setToastMessage}
          />
        );
      case PRICING_SHARE_PLAN:
        return (
          <PricingSharePlan
            {...props}
            setShowSuccessToast={setShowSuccessToast}
          />
        );
      case BUNDLE_DOCS:
        return (
          <BundleDocs
            {...props}
            setShowSuccessToast={setShowSuccessToast}
            setToastMessage={setToastMessage}
          />
        );
      case RETIRED_PRICING_PLANS:
        return (
          <RetiredPricingPlans
            {...props}
          />
        );

      case BUNDLE_PRICE_PLAN_HISTORY:
        return (
          <BundlePricePlanHistory
            {...props}
          />
        );
      case ADD_A_PLAN:
        return (
          <AddAPlan
            {...props}
          />
        );
      case CREATE_A_CONTAINER:
        return (
          <CreateAContainer
            {...props}
          />
        );
      default:
        return <>Something went wrong, Please Try Again!</>;
    }
  };

  return auth?.isAuthenticated ? (
    <div>
      {renderComponent()}
      {!!showSuccessToast && (
        <Toast
          actions={[
            {
              onClick: removeToast,
              text: "Dismiss",
            },
          ]}
          position={TOAST_POSITIONS.FIXED}
          variant={TOAST_VARIANTS.POSITIVE}
          onVisibilityDurationEnd={removeToast}
          content={
            toastMessage ||
            (selectedBundle?.name
              ? `Your bundle ${selectedBundle?.name} has been updated.`
              : "Your bundle has been created and added to the list.")
          }
          id="bundle-create-toast"
        />
      )}

      {!!showSuccessToast1 && (
        <Toast
          actions={[
            {
              onClick: removeToast1,
              text: "Dismiss",
            },
          ]}
          position={TOAST_POSITIONS.FIXED}
          variant={TOAST_VARIANTS.POSITIVE}
          onVisibilityDurationEnd={removeToast1}
          content={
            toastMessage1 ||
            (selectedBundle?.name
              ? `Your bundle ${selectedBundle?.name} has been updated.`
              : "Your bundle has been created and added to the list.")
          }
          id="bundle-create-toast-1"
        />
      )}
    </div>
  ) : (
    <div></div>
  );
}

export default withAuth(ApiBundleManagement);
